import Vue from 'vue'

import ControlPanel from './ControlPanel.vue'
import NoSidebar from './NoSidebar.vue'

Vue.component('ControlPanel-layout', ControlPanel)
Vue.component('no-sidebar-layout', NoSidebar)
